export const ITERATION_TINTS = [
  {
    card: "bg-blue-50/70 border-blue-200/70 hover:border-blue-300/80",
    frame: "bg-blue-50/70 border-blue-200/70",
    panel: "bg-blue-50/40 border-blue-200/60",
    highlight: "bg-blue-400/40",
    expenseCard: "border-blue-200 bg-blue-50/70 hover:border-blue-300 hover:bg-blue-50",
    expenseBadge: "bg-blue-100 text-blue-800",
    expenseAmount: "bg-blue-700 text-white",
  },
  {
    card: "bg-amber-50/70 border-amber-200/70 hover:border-amber-300/80",
    frame: "bg-amber-50/70 border-amber-200/70",
    panel: "bg-amber-50/40 border-amber-200/60",
    highlight: "bg-amber-400/40",
    expenseCard: "border-amber-200 bg-amber-50/70 hover:border-amber-300 hover:bg-amber-50",
    expenseBadge: "bg-amber-100 text-amber-800",
    expenseAmount: "bg-amber-700 text-white",
  },
  {
    card: "bg-emerald-50/70 border-emerald-200/70 hover:border-emerald-300/80",
    frame: "bg-emerald-50/70 border-emerald-200/70",
    panel: "bg-emerald-50/40 border-emerald-200/60",
    highlight: "bg-emerald-400/40",
    expenseCard: "border-emerald-200 bg-emerald-50/70 hover:border-emerald-300 hover:bg-emerald-50",
    expenseBadge: "bg-emerald-100 text-emerald-800",
    expenseAmount: "bg-emerald-700 text-white",
  },
  {
    card: "bg-rose-50/70 border-rose-200/70 hover:border-rose-300/80",
    frame: "bg-rose-50/70 border-rose-200/70",
    panel: "bg-rose-50/40 border-rose-200/60",
    highlight: "bg-rose-400/40",
    expenseCard: "border-rose-200 bg-rose-50/70 hover:border-rose-300 hover:bg-rose-50",
    expenseBadge: "bg-rose-100 text-rose-800",
    expenseAmount: "bg-rose-700 text-white",
  },
  {
    card: "bg-purple-50/70 border-purple-200/70 hover:border-purple-300/80",
    frame: "bg-purple-50/70 border-purple-200/70",
    panel: "bg-purple-50/40 border-purple-200/60",
    highlight: "bg-purple-400/40",
    expenseCard: "border-purple-200 bg-purple-50/70 hover:border-purple-300 hover:bg-purple-50",
    expenseBadge: "bg-purple-100 text-purple-800",
    expenseAmount: "bg-purple-700 text-white",
  },
];

export const getIterationTint = (iterationIndex) =>
  ITERATION_TINTS[Math.max(0, iterationIndex) % ITERATION_TINTS.length];
